import { IMyWindow } from '@my-backoffice/app/shared/interfaces/my-window.interface';
import { SwReloadForUpdateService } from '@my-backoffice/app/shared/services/service-worker-services/sw-reload-for-update/sw-reload-for-update.service';
import { WINDOW } from '@my-backoffice/app/shared/tokens/window.token';
import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { from, Observable, of } from 'rxjs';
import { catchError, switchMap, timeout } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SwUpdateCheckGuard implements CanActivate {
  public constructor(
    @Inject(WINDOW) private readonly _window: IMyWindow,
    private readonly _swUpdate: SwUpdate,
    private readonly _router: Router,
    private readonly _swReloadForUpdateService: SwReloadForUpdateService
  ) {}

  public canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (!this._swUpdate.isEnabled) {
      this._navigateToHome();

      return of(false);
    }

    this._swReloadForUpdateService.disableAutoReload();

    return from(this._swUpdate.checkForUpdate()).pipe(
      switchMap((hasUpdate: boolean): Observable<boolean> => {
        if (hasUpdate) {
          this._window.location.href = state.url;

          return of(false);
        }

        this._navigateToHome();

        return of(false);
      }),
      timeout(5000),
      catchError((_error: unknown): Observable<boolean> => {
        this._navigateToHome();

        return of(false);
      })
    );
  }

  private _navigateToHome(): void {
    this._swReloadForUpdateService.enableAutoReload();
    void this._router.navigate(['/home']);
  }
}
